import { render, staticRenderFns } from "./card.vue?vue&type=template&id=839cd962&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('839cd962')) {
      api.createRecord('839cd962', component.options)
    } else {
      api.reload('839cd962', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=839cd962&", function () {
      api.rerender('839cd962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/card.vue"
export default component.exports